import React from 'react'
import VacanciesItemModule from '../../Modules/VacanciesItemModule/VacanciesItemModule'

const VacanciesItemPage = () => {
  return (
    <div>
      <VacanciesItemModule/>
    </div>
  )
}

export default VacanciesItemPage
